import { Component, HostBinding, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatchingPropertyStore } from 'app/event/service/matching-property.store';
import { Observable } from 'rxjs/Observable';
import { CompletedUnpaidDashboardStore } from '../../event/service/completed-unpaid-dashboard.store';
import { EventSearchParametersStore } from '../../event/service/event-search-parameters.store';
import { MissingAgencyDashboardStore } from '../../event/service/missing-agency-dashboard.store';
import { PredefinedSearchService } from '../../event/service/predefined-search.service';
import { DashboardUtils } from '../../event/utils/dashboard-util';
import { MenuStore } from '../service/menu.store';
import { MSTRHttpService } from '../../event/service/mstr.http.service';
import { MSTR } from '../../event/models/mstr';
import { InvoiceHistoryStore } from 'app/event/service/invoice-history.store';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { AuthenticationStore } from '../../permission/services/authentication.store';
import { MatchingAgencyStore } from '../../event/service/matching-agency.store';

@Component({
  selector: 'pioneer-app-menu',
  templateUrl: './app-menu.component.html'
})
export class AppMenuComponent implements OnInit, OnDestroy {

  @HostBinding('class.left-nav') true;
  @HostBinding('class.nav-collapsed')
  isNavCollapsed;

  public showInvoiceHistory = false;

  private _destroyed$ = new Subject<void>();

  constructor(
    private menuStore: MenuStore,
    private router: Router,
    private eventSearchParametersStore: EventSearchParametersStore,
    private completedUnpaidStore: CompletedUnpaidDashboardStore,
    private missingAgencyStore: MissingAgencyDashboardStore,
    private predefinedSearchService: PredefinedSearchService,
    private matchingPropertyStore: MatchingPropertyStore,
    private matchingAgencyStore: MatchingAgencyStore,
    private mstrHttpService: MSTRHttpService,
    private invoiceHistoryStore: InvoiceHistoryStore,
    private authenticationStore: AuthenticationStore,
  ) {
  }

  ngOnInit(): void {
    this.isNavCollapsed = this.menuStore.isNavCollapsed;
    if (!this.authenticationStore.isSupportUser() &&
      // ME-17394 - hide Invoice History for permission ViewOnlyUserEvents (Agency Planner)
      !this.authenticationStore.hasPermission(['ViewOnlyUserEvents'])) {
      this.invoiceHistoryStore.getInvoiceHistoryEnabled().pipe(
        takeUntil(this._destroyed$)
      ).subscribe((enabled: boolean) => {
        this.showInvoiceHistory = enabled;
      });
    }
  }

  ngOnDestroy(): void {
    this._destroyed$.next();
    this._destroyed$.complete();
  }

  toggleNavCollapsed(): void {
    this.isNavCollapsed = this.menuStore.toggleIsNavCollapsed();
  }

  /**
   * Matches the '/events' route
   * Matches the '/events?...' route
   * Does NOT match the '/events/add' route
   * @return {boolean}
   */
  isOnSearchEvents(): boolean {
    return this.isUrlOnPath('/events') || this.isUrlOnPath('/events/financial');
  }

  isOnDashboard(): boolean {
    return this.isUrlOnPath('/dashboard');
  }

  isUrlOnPath(path: string) {
    let url = this.router.url;
    let indexOfQuestionMark = url.indexOf('?');

    // if there is a question mark in the url,
    //   then get the url up to the question mark
    if (indexOfQuestionMark >= 0) {
      url = url.substr(0, indexOfQuestionMark);
    }

    // check to see if on the events route
    return !!(url && url === (path));
  }

  navigateToSearch(): void {
    this.eventSearchParametersStore.updateUrl(true);
  }

  get completedAndUnpaidTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.completedUnpaidStore.completedAndUnpaidTotal);
  }

  get missingAgencyTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.missingAgencyStore.missingAgencyTotal);
  }

  get propertyMatchesTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.matchingPropertyStore.totalPropertyCount);
  }

  get agencyMatchesTotal(): Observable<string> {
    return DashboardUtils.totalAsStringClampedTo99(this.matchingAgencyStore.count);
  }

  showCompletedAndUnpaidTotals(): Observable<boolean> {
    return Observable.combineLatest(
      this.completedUnpaidStore.isLoading(),
      this.completedUnpaidStore.isStale()
    ).map(values => {
      const [loading, stale] = values;
      return !Boolean(loading || stale);
    });
  }

  showMissingAgencyTotals(): Observable<boolean> {
    return Observable.combineLatest(
      this.missingAgencyStore.isLoading(),
      this.missingAgencyStore.isStale()
    ).map(values => {
      const [loading, stale] = values;
      return !Boolean(loading || stale);
    });
  }

  missingAgencyPredefinedSearch() {
    this.predefinedSearchService.missingAgencySearch();
  }

  completedAndUnpaidPredefinedSearch() {
    this.predefinedSearchService.completedAndUnpaid();
  }

  callMicrostrategy() {
    this.mstrHttpService.getLink().subscribe(
      (res: MSTR) => {
        window.open(res.url, '_blank');
      });
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/menus/app-menu/app-menu.component.ts